// Basic imports
import React from 'react';

// Component imports
import { Button } from 'primereact/button';
import { Timeline } from 'primereact/timeline';
import { Image } from 'primereact/image';
import { Divider } from 'primereact/divider';
import { Carousel } from 'primereact/carousel';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';

// Style imports
import './App.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/md-dark-deeppurple/theme.css';
import 'primeicons/primeicons.css';

export default function App() {
    const [infoModalOpen, setInfoModalOpen] = React.useState(false);
    const [termsModalOpen, setTermsModalOpen] = React.useState(false);

    const timeline = [
    	{
  			id: "accommodation",
			title: <h3 style={{margin: "8px 0px"}}>Preparing for the Taikai: Accommodation</h3>,
			date: "11.04.2026",
			image: <Image className="timelineContentImage floatRight" src="../Someya Taikai Website/SenateSquare.avif" alt="Photo of the Senate Square in Helsinki."/>,
			content: <div>
               <small className="postDate textAlignLeft" >Posted on: 11.04.2026</small>
               {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Ticket/Taikai_Tshirt_2.avif" alt="Graphic representation of the Taikai t-shirt, an anthracite t-shirt with a modified Taikai logo on it."/></div>}
               <div className="textOverImage">
                   <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>Peruse the list of options for accommodation we have prepared for your convenience</p>
                   <Divider/>
                   <p style={{padding: "0 20px"}}>
                   	Helsinki City Center is full of hotels. Here are some of those and a couple of other options near the training venue:
                    <ul style={{listStyle: "none"}}>
                      <li>
                      		<a
                        		href="https://valo.fi/en/hotel/"
                           		target="_blank"
                             	rel="noreferrer"
                        	>
                         		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Valo hotel</p>
                      		</a>
                      		<p>
                     			Address: Mannerheimintie 109, Helsinki
                        		<br/>
                        		Valo is a hotel that emphasizes eco-friendliness and versatile use of space. About 20 minutes to the training venue by bus and 25 minutes to the Helsinki City Center.
                           		<br/>
                           		<span style={{fontWeight: "bold"}}>Subscribe to the Someya Taikai Finland newsletter and get a discount code for the hotel!</span>
                        	</p>
                        	<Divider/>
                      	</li>
                       	<li>
                       		<a
	                 			href="https://www.scandichotels.com/en/hotels/scandic-pasila"
	                      		target="_blank"
	                           	rel="noreferrer"
                      		>
                        		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Scandic Pasila</p>
                       		</a>
                       		<p>
                      			Address: Maistraatinportti 3, Helsinki
                         		<br/>
                         		Next to the Mall of Tripla (a huge shopping center) and Pasila Railway Station. About 30 minutes to the training venue by bus (59) and 15 minutes to the Helsinki City Center by train.
                           		<br/>
                           		<span style={{fontWeight: "bold"}}>Subscribe to the Someya Taikai Finland newsletter and get a discount code for the hotel!</span>
                         	</p>
                          	<Divider/>
                       	</li>
                        <li>
                       		<a
	                 			href="https://www.scandichotels.com/en/hotels/scandic-helsinki-station"
	                      		target="_blank"
	                           	rel="noreferrer"
                      		>
                        		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Scandic Helsinki Station</p>
                       		</a>
                       		<p>
                      			Address: Elielinaukio 5, Helsinki
                         		<br/>
                         		Next to the Helsinki Central Railway Station. About 35 minutes to the training venue by bus and 15 minutes walk to the Dinner Party place.
                           		<br/>
                            	<span style={{fontWeight: "bold"}}>Subscribe to the Someya Taikai Finland newsletter and get a discount code for the hotel!</span>
                             	<br/>
                             	<br/>
                             	Nearby you can also find the following Scandic Hotels:
                              	<br/>
                              	<a
	                               	href="https://www.scandichotels.com/en/hotels/scandic-grand-central-helsinki"
		                      		target="_blank"
		                           	rel="noreferrer"
                               	>
                                	SCANDIC GRAND CENTRAL HELSINKI
                               	</a>
                                <br/>
                                <a
	                               	href="https://www.scandichotels.com/en/hotels/scandic-kaisaniemi"
		                      		target="_blank"
		                           	rel="noreferrer"
                                >
                                 	SCANDIC KAISANIEMI
                                </a>
                                <br/>
                                 <a
	                               	href="https://www.scandichotels.com/en/hotels/marski-by-scandic"
		                      		target="_blank"
		                           	rel="noreferrer"
                                >
                                  	SCANDIC MARSKI
                                </a>
                         	</p>
                         	<Divider/>
                       	</li>
                        <li>
                       		<a
	                 			href="https://www.scandichotels.com/en/hotels/scandic-simonkentta"
	                      		target="_blank"
	                           	rel="noreferrer"
                      		>
                        		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Scandic Simonkenttä</p>
                       		</a>
                       		<p>
                      			Address: Simonkatu 9, Helsinki
                         		<br/>
                         		Next to the Kamppi shopping center and Kamppi Bus Terminal. About 35-40 minutes to the training venue by bus and 15 minutes walk to the Dinner Party place.
                           		<br/>
                           		<span style={{fontWeight: "bold"}}>Subscribe to the Someya Taikai Finland newsletter and get a discount code for the hotel!</span>
                         	</p>
                         	<Divider/>
                       	</li>
                        <li>
                       		<a
	                 			href="https://nolistudios.com/en/noli-myyrmaki-vantaa"
	                      		target="_blank"
	                           	rel="noreferrer"
                      		>
                        		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Noli Myyrmäki</p>
                       		</a>
                       		<p>
                      			Address: Raappavuorentie 4, 01600 Vantaa
                         		<br/>
                         		About 20-25 minutes to the training venue and around 60 minutes to the Helsinki City Center by bus. Please note that due to construction work, in July you can get from Airport to Myyrmäki by train but not any further toward the Helsinki City Center.
                         	</p>
                         	<Divider/>
                       	</li>
                        <li>
                       		<a
	                 			href="https://www.forenom.com/hostels/helsinki/forenom-hostel-helsinki-pitajanmaki/145?checkin=null&checkout=null&occupants=1"
	                      		target="_blank"
	                           	rel="noreferrer"
                      		>
                        		<p style={{fontWeight: "bold", textTransform: "uppercase"}}>Forenom hostel Helsinki Pitäjänmäki</p>
                       		</a>
                       		<p>
                      			Address: Kornetintie 10, 00380 Helsinki
                         		<br/>
                         		About 15 minutes to the training venue and about 25 minutes to the Helsinki City Center by bus.
                         	</p>
                       	</li>
                    </ul>
                   </p>
               </div>
           </div>
    	},
     	{
   			id: "practice-weapons",
			title: <h3 style={{margin: "8px 0px"}}>Preparing for the Taikai: Practice Weapons</h3>,
			date: "11.04.2026",
			image: <Image className="timelineContentImage floatLeft" src="../Someya Taikai Website/Gin_Tama_Bokken.avif" alt="Photo of wooden practice swords bundled together."/>,
			content: <div>
                <small className="postDate textAlignRight" >Posted on: 11.04.2026</small>
                {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Website/Gin_Tama_Bokken.avif" alt="Photo of wooden practice swords bundled together."/></div>}
                <div className="textOverImage">
                    <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>The theme of the Taikai is taijutsu, sword and Kyoketsu Shoge.</p>
                    <Divider/>
                    <p style={{padding: "0 20px"}}>
                        We have prepared a number of Kyoketsu Shoge for you to loan at the venue, which can also be purchased during and immediately after the Taikai. If you have a sword or a Kyoketsu Shoge and wish to bring these to the Taikai for practice purposes, please make sure that the practice weapons you bring with you are safe for both the other participants as well as the tatami. In other words, please make sure the practice weapon or weapons you bring are not sharp and preferably made of such materials as rubber, wood or similar safe material. A bokken or a soft sword are ideal, as well as plastic/rubber Kyoketsu Shoge with soft rubber weights.
                    </p>
                    <p style={{padding: "0 20px"}}>
                    	As mentioned, the Kyoketsu Shoge will also be for sale should you wish to purchase one for future practice. They can be purchased during the Taikai for 35€/each. You cannot pre-order one, and they will be sold in order of arrival.
                    </p>
                </div>
            </div>
     	},
    	{
   			id: "shirts",
			title: <h3 style={{margin: "8px 0px"}}>T-Shirts can be preordered</h3>,
			date: "31.03.2026",
			image: <Image className="timelineContentImage floatRight" src="../Someya Taikai Ticket/Taikai_Tshirt_2.avif" alt="Graphic representation of the Taikai t-shirt, an anthracite t-shirt with a modified Taikai logo on it."/>,
			content: <div>
                <small className="postDate textAlignLeft" >Posted on: 31.03.2026</small>
                {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Ticket/Taikai_Tshirt_2.avif" alt="Graphic representation of the Taikai t-shirt, an anthracite t-shirt with a modified Taikai logo on it."/></div>}
                <div className="textOverImage">
                    <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>You can now secure your taikai t-shirt in advance!</p>
                    <Divider/>
                    <p style={{padding: "0 20px", fontWeight: "bold", fontSize: 20}}>
                       The Taikai t-shirts are available for purchase at the venue. The sizes range from XS to XXL, but please be aware that not all sizes may be available anymore. Please inquire more from the staff during the event! 
                    </p>
                    <p style={{padding: "0 20px"}}>
                    	The t-shirts are made of recycled cotton and printed with high-quality printing methods, ensuring that the material is both long-lasting as well as of good quality. These shirts will last you through both practice as well as everyday use and will be a wonderful memory of an amazing Taikai event in Finland!
                    </p>

                    {/*<a
                        href="https://holvi.com/shop/taikaifi/product/bf50d918eb12e1dc25d182cec9f2e131/"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            display: "block",
                            margin: "auto",
                            marginTop: 30,
                            marginBottom: 10,
                            width: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                            height: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                        }}
                    >
                        <Button
                            className="hoverButton"
                            style={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: "url('../Someya Taikai Ticket/Taikai_Tshirt_1.avif')",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundColor: "#00031f"
                            }}
                        />
                    </a>*/}
                </div>
            </div>
     	},
        {
            id: "dinner",
            title: <h3 style={{margin: "8px 0px"}}>Dinner tickets now available!</h3>,
            date: "8.12.2025",
            image: <Image className="timelineContentImage floatLeft" src="../Aleksi-sali_Sunn.jpg" alt="Picture of the Aleksi-sali from restaurant Sunn in Helsinki"/>,
            content: <div>
                <small className="postDate textAlignRight" >Posted on: 8.12.2025</small>
                {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Aleksi-sali_Sunn.jpg" alt="Picture of the Aleksi-sali from restaurant Sunn in Helsinki"/></div>}
                <div className="textOverImage">
                    <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>Tickets for the saturday dinner are available!</p>
                    <Divider/>
                    <p style={{padding: "0 20px"}}>
                        Saturday's (11th of July) dinner event will be held in restaurant Sunn in central Helsinki (Aleksanterinkatu 26, 2nd floor, 00170 Helsinki). The restaurant is situated in a wonderful location just across the Helsinki Cathedral, offering a beautiful view of the Senate Square. Dress code for the dinner is smart casual.
                    </p>
                    <p style={{padding: "0 20px"}}>
                        The timetable for the dinner is as follows:
                    </p>
                    <ul style={{marginLeft: window.innerWidth < 800 ? 5 : 30}}>
                        <li><span style={{fontWeight: "bold"}}>19:00</span>  - Recommended arrival time</li>
                        <li><span style={{fontWeight: "bold"}}>19:30</span>  - Food serving begins</li>
                    </ul>
                    <p style={{padding: "0 20px", fontSize: "20px", fontWeight: "bold"}}>
                      The dinner tickets are no longer available. Thank you for your interest!
                    </p>

                      {/*<a
                        href="https://holvi.com/shop/taikaifi/product/6d19ffee6e0036429f3dd8a4a21a6145/"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            display: "block",
                            margin: "auto",
                            marginTop: 30,
                            marginBottom: 10,
                            width: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                            height: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                        }}
                    >
                        <Button
                            className="hoverButton"
                            style={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: "url('../Someya Taikai Ticket/Someya-Taikai-DinnerTicket.avif')",
                                backgroundSize: "cover"
                            }}
                        />
                    </a>*/}
                </div>
            </div>
        },
        {
            id: "location",
            title: <h3 style={{margin: "8px 0px"}}>Location for the Taikai</h3>,
            date: "8.12.2025",
            image: <div className="floatRight">
           		<Image className="timelineContentImage" src="../Someya Taikai Website/Ristipellontie_Konala_Aerial.avif" alt="Aerial picture of the Konala area in Helsinki"/>
            	<Image className="timelineContentImage" src="../Someya Taikai Website/Tatami.avif" alt="Picture of the inside of the training hall"/>
            </div>,
            content: <div>
                <small className="postDate textAlignLeft" >Posted on: 8.12.2025</small>
                {window.innerWidth < 800 && <div style={{marginTop: 20}}>
               	<Image className="timelineContentImage" src="../Someya Taikai Website/Ristipellontie_Konala_Aerial.avif" alt="Aerial picture of the Konala area in Helsinki"/>
                	<Image className="timelineContentImage" src="../Someya Taikai Website/Tatami.avif" alt="Picture of the inside of the training hall"/>
                </div>}
                <div className="textOverImage">
                    <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>The Taikai location is confirmed!</p>
                    <Divider/>
                    <p style={{padding: "0 20px"}}>
                        The Taikai location has been confirmed, and the Taikai will take place in the <span style={{fontWeight: "bold", fontSize: 20}}>Tu11 training center</span> in Konala, Helsinki (Ristipellontie 14, 00390 Helsinki).
                    </p>
                    <p style={{padding: "0 20px"}}>
                        The training center is easily reached from both the airport and central Helsinki. From both the airport and central Helsinki direction, a combination of train and bus carries you directly in front of the training center. You can also opt to walk some of the distance, as the nearest train station is only a 20 minute walk away.
                        You can consult the <a href="https://www.hsl.fi/en">HSL Journey Planner</a> to help you navigate to the location. Ticket purchases are also possible to make on the HSL application, available from both Play Store on Android and App Store on iOS.
                    </p>
                    <p style={{padding: "0 20px"}}>
                        The Ristikko shopping center is also found nearby with plenty of options for lunch through several restaurants as well as a food court. The shopping center also includes general stores, from where you can buy smaller snack items and anything else you might need during the Taikai!
                    </p>
                    <Divider/>
                    <iframe
                    	title="Venue Map"
                        width="90%"
                        height="300"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=24.839766025543213%2C60.23942240751612%2C24.850280284881595%2C60.24272940407817&amp;layer=mapnik&amp;marker=60.2410759475269%2C24.845023155212402"
                        style={{border: "3px solid rgba(66, 66, 82, 0.8)", borderRadius: 15, display: "flex", margin: "auto", marginTop: 30}}
                    >
                        Loading map...
                    </iframe>
                    <small style={{marginLeft: "7%"}}>
                        <a href="https://www.openstreetmap.org/?mlat=60.241076&amp;mlon=24.845023#map=18/60.241076/24.845023">View Larger Map</a>
                    </small>
                </div>
            </div>
        },
        {
            id: "tickets",
            title: <h3 style={{margin: "8px 0px"}}>Ticket sales begin!</h3>,
            date: "20.10.2025",
            image:
            	<a
	                href="https://holvi.com/shop/taikaifi/section/someya-taikai-finland-10-12-july-2026/"
	                target="_blank"
	                rel="noreferrer"
	            >
	            	<Image
						className="timelineContentImage floatLeft"
						src="../Someya Taikai Ticket/Someya Taikai TicketSales-1.avif"
						alt="Picture of the taikai ticket"
					/>
				</a>,
            content: <div>
                        <small className="postDate textAlignRight" >Posted on: 20.10.2025</small>
                        {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Ticket/Someya Taikai TicketSales-1.avif" alt="Picture of the taikai ticket"/></div>}
                        <div className="textOverImage">
                            <p style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>Ticket sales have started!</p>
                            <Divider/>
                            <p style={{padding: "0 20px"}}>Get yourself the <span style={{fontWeight: "bold", fontSize: 20, margin: 5}}>FULL THREE-DAY</span> ticket — priced at 250€ — allowing you to experience all three days of the taikai at a lower price than the individual tickets. Join us for an event to remember!</p>
                            <p style={{padding: "0 20px"}}>You can still also purchase a one-day ticket, if you already know you have a busy summer ahead of you next year, but you'd still like to join the taikai and enjoy sensei's teaching! Friday ticket costs 60€, and saturday/sunday tickets cost 120€ each.</p>
                            <Divider/>
                            <p style={{padding: "0 20px", marginBottom: 40, fontWeight: "bold", fontSize: 20}}>The ticket sales have ended, thank you for everyone who joined us for this event!</p>
                            {/*<div style={{display: "flex", flexDirection: "row", justifyContent: 'center', flexWrap: "wrap"}}>
                                <a
                                    href="https://holvi.com/shop/taikaifi/product/e6d191767cda769a12962d52a2af60a6/"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        width: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                                        height: (window.innerWidth < 1300 && window.innerWidth > 800) ? 200 : window.innerWidth < 800 ? 150 : 300,
                                        marginBottom: 10,
                                        marginLeft: 10,
                                        marginRight: 10
                                    }}
                                >
                                    <Button
                                        className="hoverButton"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            backgroundImage: "url('../Someya Taikai Ticket/3_day_ticket.avif')",
                                            backgroundSize: "cover"
                                        }}
                                    />
                                </a>
                                <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", width: window.innerWidth > 2045 ? '50%' : '100%', justifyContent: "center"}}>
                                    <a
                                        href="https://holvi.com/shop/taikaifi/product/85cb9fee6b09ef205d7bc8bef3b2c29c/"
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{width: 145, height: 145, margin: "0px 5px 10px 5px"}}
                                    >
                                        <Button
                                            className="hoverButton"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: "url('../Someya Taikai Ticket/1_day_ticket.FRIDAY.avif')",
                                                backgroundSize: "cover"
                                            }}
                                        />
                                    </a>
                                    <a
                                        href="https://holvi.com/shop/taikaifi/product/814c6009c55bb89de6b2364e097842fd/"
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{width: 145, height: 145, margin: "0px 5px 10px 5px"}}
                                    >
                                        <Button
                                            className="hoverButton"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: "url('../Someya Taikai Ticket/1_day_ticket.SATURDAY.avif')",
                                                backgroundSize: "cover"
                                            }}
                                        />
                                    </a>
                                    <a
                                        href="https://holvi.com/shop/taikaifi/product/13a55107a257ba493ac0951738548cec/"
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{width: 145, height: 145, margin: "0px 5px 10px 5px"}}
                                    >
                                        <Button
                                            className="hoverButton"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: "url('../Someya Taikai Ticket/1_day_ticket.SUNDAY.avif')",
                                                backgroundSize: "cover"
                                            }}
                                        />
                                    </a>
                                </div>
                            </div>*/}
                            <div style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                                <Button
                                    severity="info"
                                    size="large"
                                    text
                                    raised
                                    onClick={() => setTermsModalOpen(true)}
                                >
                                    Terms and Conditions
                                </Button>
                            </div>
                        </div>
                    </div>,
            collapsed: false,
            toggleable: false
        },
        {
            id:"taikai-info",
            title: <h3 style={{margin: "8px 0px"}}>Someya Sensei Tai Kai Finland 10.- 12.7.2026</h3>,
            date: "21.05.2025",
            image: <Image className="timelineContentImage floatRight" src="../Someya Taikai Website/HelsinkiAerial1.avif" alt="Aerial picture of Helsinki"/>,
            content: <div>
                        <small className="postDate textAlignLeft" >Posted on: 21.05.2025</small>
                        {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Website/HelsinkiAerial1.avif" alt="Aerial picture of Helsinki"/></div>}
                        <div className="textOverImage">
                            <p>Event information has been updated!</p>
                            <p>Come join us at a training event to remember. Someya sensei has been kind enough to accept our invitation to come teach us in Helsinki, Finland. The theme is Buyu Kai (武勇会), martial gathering of courage, and the theme will focus on kenjutsu as well as the use of kyoketsu shoge. In Tai Kai tradition there will be a dinner party at Saturday evening, where an evening of good food and friends awaits you.</p>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Venue</h3>
                                <p>Tu11 Training Center, Ristipellontie 14, 00390 Helsinki</p>
                                <p>The Tu11 training center is an industrial property modified for sports use. The center includes over 600m² tatami area with air conditioning and dressing rooms. The Ristikko shopping center with its restaurants is only a 5-minute-walk away!</p>
                                <p>The venue is accessible by various buses and trains from central Helsinki and the airport. We recommend using the <a href="https://www.hsl.fi/en">HSL Journey Planner</a> to search for public transport options.</p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Timetable:</h3>
                                <p>10.- 12.7.2026<br/><br/>Friday — Doors & registration opens at  16:00, training 18.00 - 21.00<br/>Saturday — Doors & registration opens at 9:00, training 10.00 - 13.00 / lunch break / training 14.30 - 17.00<br/>Sunday — Doors open at 9:00, training 10.00 - 13.00 / lunch break / training 14.30 - 17.00</p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Price:</h3>
                                <p>
                                    Tai Kai Regular Ticket 250 € (3-day ticket, covers Friday-Sunday, available from 1.3.2026 onwards)
                                </p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Dinner Party</h3>
                                <p>
                                    Come to celebrate the evening with your fellow bujis on Saturday 11.7.2026 from 19.00 onwards.
                                    <br/>
                                    Place: Restaurant Sunn. Aleksanterinkatu 26, 00170 Helsinki. 2nd floor.
                                </p>
                                <p>
                                    The restaurant includes a rich buffet table, offering both vegetarian and meat options. The bar is serving drinks at your own expense.
                                    The tickets for the dinner are no longer available.
                                </p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Accommodation</h3>
                                <p>
                                    We offer promotional discount codes for selected hotels in Helsinki area. To receive them and take advantage of the unique offers, join our mailing list by pressing the button at the top of the screen!
                                </p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>T-Shirts</h3>
                                <p>
                                  Available for purchase at the venue. Please note that not all sizes (ranging from XS to XXL) may be available.	
                                </p>
                            </div>
                            <Divider/>
                            <div style={{padding: window.innerWidth < 800 ? 0 : "0px 20px"}}>
                                <h3 className="removeTopMargin" style={{fontWeight: "bold"}}>Practice materials</h3>
                                <p>
                                    We have constructed several kyoketsu-shoge for the use of the Tai Kai. These practice weapons will be at your free use during the Tai Kai, and you can also purchase one for yourself during the TaiKai as a keepsake or to use for your own practice!
                                </p>
                                <p>
                                  Local budo store, <a href="http://www.meijin.fi/" target="_blank" referrerPolicy='no-referrer' rel="noreferrer">Meijin Budoshop</a>, is offering discounts on Bujinkan-related budo equipment. If you wish to upgrade your practice gear or you are in the market for high-quality japanese-made budo equipment, head over to Meijin Budoshop!
                                </p>
                            </div>
                        </div>
                    </div>,
            collapsed: false,
            toggleable: false
        },
        {
            id: "someya-sensei",
            title: <h3 style={{margin: "8px 0px"}}>Someya Kenichi DaiShihan</h3>,
            date: "21.05.2025",
            image: <Image className="timelineContentImage floatLeft" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img3.avif" alt="Picture of Someya Kenichi Sensei in a stance with a sword"/>,
            backgroundImage: null,
            content: <div>
                        <small className="postDate textAlignRight" >Posted on: 21.05.2025</small>
                        {window.innerWidth < 800 && <div style={{marginTop: 20}}><Image className="timelineContentImage" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img3.avif" alt="Picture of Someya Kenichi Sensei in a stance with a sword"/></div>}
                        <div className="textOverImage">
                            <ul style={{fontWeight: "bold", listStyle: "none", paddingLeft: 0}}>
                                <li>Battôjutsu, Menkyo Kaiden</li>
                                <li>Togakure ryu Ninja Biken, Menkyo Kaiden</li>
                                <li>Kôtô ryu Koppôjutsu, Happô Hiken Menkyo Kaiden</li>
                                <li>Gyokko ryu Kosshijutsu, Menkyo Kaiden</li>
                            </ul>
                            <p>Someya Kenichi Dai Shihan is one of the most important teachers in the Bujinkan. He has a strong emphasis in kihon (basics) and has a love of sword techniques. In his training in Japan there is a sense of study and a connection to the history and tradition of budo. Sensei usually begins his training by asking those present what they want to train and without fail delivers, helping everyone on their own personal budo journey (shugyo).</p>
                        </div>
                    </div>,
            collapsed: false,
            toggleable: false
        },
    ]

    const loadMessages = [
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img1.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img7.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/HelsinkiCathedral.avif" alt="The Uspenski Cathedral in Helsinki"width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img2.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img9.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img3.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/HelsinkiStatue.avif" alt="A statue in front of a historical building in Helsinki" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img5.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/HelsinkiStation.avif" alt="Statues against the facade of the Helsinki central train station" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img6.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/HelsinkiPort.avif" alt="A ship in a port in Helsinki" width="200" height="200" style={{objectFit: "cover"}} />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img4.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img8.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/Someya_Taikai_Carousel_Img10.avif" alt="Someya Kenichi Sensei in a stance with a sword" width="200" height="200" />,
        <img className="carouselImg" src="../Someya Taikai Website/TatamiInside.avif" alt="Inside view of the training hall for the Taikai" width="200" height="200" />
    ]

    const loadMessageTemplate = (loadMessage) => {
        return (
            <div style={{textAlign: "center", height: 200, width: "100%", alignContent: "center"}}>{loadMessage}</div>
        )
    };

    const timelineContent = (item) => {
        return (
            <Panel
                id={item.id}
                header={item.title}
                ref={item.ref}
                toggleable={item.toggleable}
                collapsed={item.collapsed}
                collapseIcon={item.ref &&
                    <i
                        className="pi pi-chevron-up"
                        onClick={(e) => {
                            item.ref.current.toggle(e);
                        }}
                    ></i>}
                expandIcon={item.ref &&
                    <i
                        className="pi pi-chevron-down"
                        onClick={(e) => {
                            item.ref.current.toggle(e);
                        }}
                    ></i>}
                style={{marginBottom: 50, marginTop: -10}}
            >
                <div
                    style={{
                        paddingTop: 5,
                        paddingBottom: 5,
                        textAlign: "left",
                        borderRadius: 10
                    }}
                >
                    <div style={{padding: "5px 20px"}}>
                        {item.content}
                    </div>
                </div>
            </Panel>
        )
    };

    const toggleSubscribeModal = () => {
        document.getElementById("subscriptionModal").className !== "modalOpen"
        ? document.getElementById("subscriptionModal").className = "modalOpen"
        : document.getElementById("subscriptionModal").className = "modalClosed"
    }

    React.useEffect(() => {
	    document.getElementById('siteContent')?.addEventListener(
	    	'scroll',
	     	(event) => {
				let scrollPos = document.getElementById('siteContent')?.scrollTop;
				if (scrollPos > 300) document.getElementById('scrollToTop').style.visibility = 'visible';
				else document.getElementById('scrollToTop').style.visibility = 'hidden';
	      	},
	       { passive: true }
	    );
    }, [])

    return (
        <div
        	id="siteContent"

        >
            <div id="subscriptionModal" className="modalClosed">
                <div id="audienceful-fK3Swv"></div>

                <Button
                    id="subscribeModalCloseButton"
                    label="Close"
                    onClick={toggleSubscribeModal}
                />
            </div>

            <div
            	id="scrollToTop"
            	style={{
             		position: "absolute",
               		bottom: 10,
                 	right: 30,
                  	zIndex: 9
             	}}
            >
            	<Button
             		icon="pi pi-chevron-up"
               		rounded
                 	onClick={() => {
                  		let elem = document.getElementById("siteContent");
						if (elem) elem.scroll({
							top: 0,
							left: 0,
							behavior: "smooth"
						});
                  	}}
                />
            </div>

            <div id="contentWrapper">
                <Button
                    id="infoButton"
                    icon=<i className="pi pi-question-circle" style={{fontSize: "35px"}}></i>
                    rounded
                    onClick={() => setInfoModalOpen(true)}
                />
                <div id="content">
                    <div id="bannerWrapper">
                        <Image id="bannerImg" src="../Someya_Taikai_Logo_2026.avif" alt="Someya Taikai Logo" width="200" />

                        <h1 id="bannerTitle">SOMEYA TAIKAI</h1>
                        <h2 id="bannerSubTitle">10.- 12.7.2026 — FINLAND</h2>
                    </div>

                    <Divider className="wideDivider" />
                    <Carousel
                        id="promoCarousel"
                        value={loadMessages}
                        itemTemplate={loadMessageTemplate}
                        numVisible={window.innerWidth < 800 ? 1 : 5}
                        autoplayInterval={10000}
                        showNavigators={false}
                        showIndicators={false}
                        circular={true}
                    />
                    <Divider className="wideDivider" />

                    <div
                    	style={{
                     		display: "flex",
                       		flexDirection: "row",
                         	flexWrap: "wrap",
                         	justifyContent: "center",
                          	gap: 20,
                          	alignItems: "center",
                            marginBottom: 30,
                     	}}
                    >
                  		<Button
                    		link
	                        className="heroActionButton"
	                        outlined
	                        icon="pi pi-ticket"
	                        label="Get your ticket"
	                        onClick={() =>  window.open("https://holvi.com/shop/taikaifi/section/someya-taikai-finland-10-12-july-2026/", '_blank')}
	                    />
	                    <Button
	                        className="heroActionButton"
	                        outlined
	                        icon="pi pi-envelope"
	                        label="Subscribe to the newsletter"
	                        onClick={toggleSubscribeModal}
	                    />
						<Button
	                        className="heroActionButton"
	                        outlined
	                        icon="pi pi-home"
	                        label="Event info"
	                        onClick={() => {
								let elem = document.getElementById("taikai-info");
						        if (elem) elem.scrollIntoView({
						            behavior: "smooth",
						            block: "start",
						            inline: "start",
						        });
							}}
	                    />
						<Button
                    		link
	                        className="heroActionButton"
	                        outlined
	                        icon="pi pi-video"
	                        label="Previous Taikai Videos"
	                        onClick={() =>  window.open("https://holvi.com/shop/taikaifi/section/video-shiraishi-taikai-finland-27-29th-june-2025/", '_blank')}
	                    />
                    </div>

                    <Timeline
                        id="taikaiTimeline"
                        value={timeline}
                        content={timelineContent}
                        opposite={(item) => ((item.image && window.innerWidth) > 800 ? item.image : null)}
                        align={window.innerWidth < 800 ? 'left' : 'alternate'}
                    />
                </div>
            </div>

            <Dialog
                id="infoModal"
                header="Info"
                visible={infoModalOpen}
                position="top"
                onHide={() => setInfoModalOpen(false)}
            >
                <div id="infoModalContent">
                    <p>This event is hosted and organized by Taikai Ry (Registered association, VAT-ID 3426746-7).</p>
                    <p>
                        In case you have questions about the Taikai, please contact us at <span><a href="mailto:mailbox.someyataikai@gmail.com">mailbox.someyataikai(at)gmail.com</a></span>. You can also unsubscribe from the newsletter by sending an email to the same address. We will answer emails within 1 - 3 business days.
                    </p>
                </div>
                <small style={{float: "right"}}>You can close this window by clicking the <span style={{fontWeight: "bold"}}>X</span> -icon at the top right or by pressing the ESC-key</small>
            </Dialog>

            <Dialog
                id="termsModal"
                header="Terms and Conditions"
                visible={termsModalOpen}
                position="top"
                onHide={() => setTermsModalOpen(false)}
            >
                <div id="termsModalContent">
                    <h2>Someya Taikai Finland Terms & Conditions</h2>
                    <b style={{fontSize: 20}}>Event Details:</b>
                    <ol>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Tickets:</b>
                            <p>1. Event tickets are being sold online at the Taikai Ry Holvi web store</p>
                            <p>2. The tickets will be delivered by email from the following address: orders@holvi.com</p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Event Entry:</b>
                            <p>A valid ticket is required. This will be checked at the venue registration area before the event.</p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Event Changes, Cancellation, and Refunds:</b>
                            <p>
                                The organizer reserves the right to make changes to the event schedule, lineup, and venue. If the event is cancelled due to unforeseen circumstances, the organizer will offer refunds.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Age Restrictions:</b>
                            <p>
                                The minimum age requirement for attendees is 18 years old. Younger individuals are permitted to participate when accompanied by an adult (18 years or older) who assumes responsibility for the minor for the duration of the event.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Denied Entry:</b>
                            <p>
                                All attendees are required to follow the Bujinkan Hombu guidelines. Those individuals who do not follow the guidelines, or are in violation thereof, are not welcome at the event and the cost of their tickets will not be refunded.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Pictures and Video:</b>
                            <p>
                                The training sessions will be recorded on video and available as an optional purchase sometime after the event. Please do not take photos or videos during the training. Photos before and after the event, as well as during the breaks, will be permitted.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Contact Information:</b>
                            <p>
                                For any inquiries, issues with tickets, or additional information, send an email to <span><a href="mailto:mailbox.someyataikai@gmail.com">mailbox.someyataikai(at)gmail.com</a></span>. By purchasing a ticket for this event, you agree to abide by these terms and conditions. Please read them carefully before making your purchase.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Insurance:</b>
                            <p>
                                Participating in the event is entirely at your own risk. The organizer will not be responsible for any damages, losses, or injuries you might sustain while participating in the training or any activity associated with the event. The attendee may arrange personal insurance for the event if desired.
                            </p>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Refund Policy</b>
                            <p>
                                To request a refund, please email us at <span><a href="mailto:mailbox.someyataikai@gmail.com">mailbox.someyataikai(at)gmail.com</a></span> and include your order details. Refund requests will be processed within 14 business days.
                            </p>
                            <ul>
                                <li>
                                    100% Refund: Requests made more than three months before the first day of the event will receive a full refund.
                                </li>
                                <li>
                                    50% Refund: Requests made between one to three months before the first day of the event will receive a 50% refund.
                                </li>
                                <li>
                                    No Refund: Requests made less than one month before the first day of the event are not eligible for a refund.
                                </li>
                            </ul>
                            <p>
                                Please note:
                            </p>
                            <ul>
                                <li>
                                    Refunds will be issued using the original payment method.
                                </li>
                                <li>
                                    Any transaction fees incurred during the original purchase are non-refundable.
                                </li>
                            </ul>
                        </li>
                        <li style={{marginBottom: 20}}>
                            <b style={{fontSize: 18}}>Change of Registrant Name:</b>
                            <p>
                                If you need to change the name of the registrant for a ticket, please send an email request to <span><a href="mailto:mailbox.someyataikai@gmail.com">mailbox.someyataikai(at)gmail.com</a></span>. The request must include the original registrant's name, the new registrant's name, and any relevant ticket details. All change requests must be received no later than 24 hours before the first day of the event.
                            </p>
                            <p>
                                Please note:
                            </p>
                            <ul>
                                <li>
                                    Name changes are subject to approval and verification.
                                </li>
                                <li>
                                    The email must be sent from the email address used during the original ticket purchase.
                                </li>
                                <li>
                                    A confirmation email will be sent once the name change has been processed.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </div>
                <small style={{float: "right"}}>You can close this window by clicking the <span style={{fontWeight: "bold"}}>X</span> -icon at the top right or by pressing the ESC-key</small>
            </Dialog>
        </div>
    );
}
